// extracted by mini-css-extract-plugin
export var banner = "topBanner-module--banner--e287d";